import queryString from 'qs';

const getNotificationRequest = (filter) => {
  const queries = { limit: 10, page: filter?.page, isRead: filter?.selectedTab === 'read' };

  return queryString.stringify(queries, { skipEmptyString: true });
};

export default getNotificationRequest;
